import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import messages from '@/i18n/lang/zh-Hant';

Vue.use(VueI18n);

const defaultLang = 'zh-Hant';

export const i18n = new VueI18n({
  locale: (navigator.language || navigator.userLanguage).toLowerCase(), // set locale
  fallbackLocale: {
    zh: ['zh-TW'],
    'zh-TW': ['zh-Hant'],
    default: [defaultLang]
  },
  silentTranslationWarn: true,
  messages: {
    ...messages
  } // set locale messages
});

const loadedLanguages = [defaultLang]; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export async function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  /*
  // If the language hasn't been loaded yet
  const messages = await import(`@/i18n/lang/${lang}`)
  i18n.setLocaleMessage(lang, messages.default)
  loadedLanguages.push(lang)
  return setI18nLanguage(lang)
  */
  return null;
}
